import { createAction } from 'redux-actions'

export const openImportSpreadsheetsDialog = createAction('OPEN_IMPORT_SPREADSHEETS_DIALOG')
export const closeImportSpreadsheetsDialog = createAction('CLOSE_IMPORT_SPREADSHEETS_DIALOG')

export const resetImportFileUploading = createAction('RESET_IMPORT_SPREADSHEETS_DIALOG')
